export default __webpack_public_path__ + "static/media/wrong.943ad3dd.jpg";